/* MR14 · Points forts (préfixe a-) : manifeste mot à mot, révélations, inclinaison 3D + lueur au pointeur,
   parallaxe de la photo, vérificateur de vitre. Aucune boucle : tout est déclenché et s'arrête. */
(function () {
  'use strict';

  function monter(sec) {
    const MR14 = window.MR14;
    const reduit = !!(MR14 && MR14.reduit) || document.documentElement.classList.contains('reduit') ||
      (window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)').matches : false);
    const fin = window.matchMedia ? matchMedia('(hover: hover) and (pointer: fine)') : null;

    // --- Révélations (en-tête et cartes) : classe a-on une seule fois ---
    const cibles = [...sec.querySelectorAll('[data-a-revele]')];
    if (reduit || !('IntersectionObserver' in window)) {
      cibles.forEach((el) => el.classList.add('a-on'));
    } else {
      const io = new IntersectionObserver((entrees) => {
        entrees.forEach((en) => {
          if (en.isIntersecting) { en.target.classList.add('a-on'); io.unobserve(en.target); }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });
      cibles.forEach((el) => io.observe(el));
    }
    // Un élément atteint au clavier est révélé tout de suite
    sec.addEventListener('focusin', (e) => {
      const c = e.target.closest && e.target.closest('[data-a-revele]');
      if (c) c.classList.add('a-on');
    });

    // --- Manifeste (progression --a-p) et parallaxe de la photo ---
    const manif = sec.querySelector('[data-a-manif]');
    const photo = sec.querySelector('[data-a-photo]');
    let pPrec = -1;
    const maj = () => {
      const vh = window.innerHeight || 800;
      if (manif) {
        let p = 1;
        if (!reduit) {
          const r = manif.getBoundingClientRect();
          p = (vh * 0.88 - r.top) / (vh * 0.5 + r.height * 0.4);
          p = Math.max(0, Math.min(1, p));
        }
        if (p !== pPrec) { pPrec = p; manif.style.setProperty('--a-p', p.toFixed(4)); }
      }
      if (photo && !reduit) {
        const r = photo.getBoundingClientRect();
        if (r.bottom > -100 && r.top < vh + 100) {
          const c = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / vh));
          photo.style.setProperty('--a-py', (c * -26).toFixed(2) + 'px');
        }
      }
    };
    if (MR14 && MR14.auDefilement) MR14.auDefilement(maj); else maj();

    // --- Inclinaison 3D + lueur au pointeur ---
    sec.querySelectorAll('[data-a-carte]').forEach((el) => {
      el.addEventListener('pointermove', (e) => {
        if (reduit || !fin || !fin.matches || e.pointerType === 'touch') return;
        const r = el.getBoundingClientRect();
        if (!r.width || !r.height) return;
        const x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
        const y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
        el.style.setProperty('--mx', (x * 100).toFixed(2) + '%');
        el.style.setProperty('--my', (y * 100).toFixed(2) + '%');
        el.style.setProperty('--ry', ((x - 0.5) * 7).toFixed(2) + 'deg');
        el.style.setProperty('--rx', ((0.5 - y) * 7).toFixed(2) + 'deg');
        el.classList.add('a-survol');
      });
      el.addEventListener('pointerleave', () => {
        el.classList.remove('a-survol');
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
      });
    });

    // --- Vérificateur de vitre ---
    const verif = sec.querySelector('[data-a-verif]');
    if (verif) {
      const cases = [...verif.querySelectorAll('[data-a-case]')];
      const segs = [...verif.querySelectorAll('[data-a-seg]')];
      const compte = verif.querySelector('[data-a-compte]');
      const msg = verif.querySelector('[data-a-msg]');
      const msgTxt = verif.querySelector('[data-a-msg-txt]');
      const total = cases.length;
      const message = (n) => {
        const reste = total - n;
        if (reste === 0) return msg.dataset.ok || 'Votre fenêtre convient.';
        if (reste === 1) return msg.dataset.un;
        return (msg.dataset.plusieurs || '').replace('N', String(reste));
      };
      let avant = -1;
      const rendre = (animer) => {
        const n = cases.filter((c) => c.checked).length;
        if (compte) compte.textContent = n + ' / ' + total;
        segs.forEach((g, i) => g.classList.toggle('a-plein', i < n));
        verif.classList.toggle('a-ok', n === total);
        if (msgTxt) msgTxt.textContent = message(n);
        if (animer && !reduit && msg && msg.animate && n !== avant) {
          msg.animate(
            [{ opacity: 0, transform: 'translateY(8px)', filter: 'blur(4px)' }, { opacity: 1, transform: 'none', filter: 'blur(0)' }],
            { duration: 460, easing: 'cubic-bezier(.23,1,.32,1)' }
          );
        }
        avant = n;
      };
      cases.forEach((c) => c.addEventListener('change', () => rendre(true)));
      rendre(false); // état réel au chargement (le navigateur peut avoir conservé des cases cochées)
    }

    // --- Carte 4 : vraie photo du coloris choisi (un coloris sans photo garde l'image affichée) ---
    const photos = [...sec.querySelectorAll('[data-a-coloris]')];
    if (photos.length && MR14) {
      const majPhoto = () => {
        if (!photos.some((im) => im.dataset.aColoris === MR14.coloris)) return;
        photos.forEach((im) => { im.hidden = im.dataset.aColoris !== MR14.coloris; });
      };
      majPhoto();
      if (MR14.surColoris) MR14.surColoris(majPhoto);
    }
  }

  const demarrer = () => document.querySelectorAll('[data-a-section]').forEach((sec) => {
    if (sec.dataset.aMonte) return;
    sec.dataset.aMonte = '1';
    monter(sec);
  });

  if (window.MR14 && window.MR14.pret) window.MR14.pret(demarrer);
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();

  // Éditeur de thème : une section rechargée est remontée
  document.addEventListener('shopify:section:load', demarrer);
})();
